// test2032
(2032 && 0);
